import React, { FC, useState } from 'react';
import injectSheet from 'react-jss';
import Menu from 'Components/Menu';
import { handleAccessibilityClick } from 'Utils/handleAccessibilityClick';
import styleSheet from './styles';

interface Props {
  shared?: string;
  count?: number;
  id?: string;
  loadAttributes?: string;
  color?: string;
  padding?: string;
  listName?: string;
  alignItems?: string;
  justifyContent?: string;
  listType?: string;
  tableColumns?: string[];
  classes?: any;
  menuConfig?: {
    use?: boolean;
    hover?: boolean;
    items?: any;
    indicator?: any;
    indicatorStyles?: any;
    onChange?: (e: object) => void;
  };
  onMouseEnter?: (event: any) => void;
  onMouseLeave?: (event: any) => void;
  onClick?: (event: any) => void;
  children: any;
}

const TableRow: FC<Props> = (props: Props) => {
  const [hovering, setHovering] = useState(false);
  const {
    shared,
    count,
    id,
    loadAttributes,
    color,
    listName = '',
    listType,
    tableColumns,
    classes,
    menuConfig,
    onMouseEnter,
    onMouseLeave,
    onClick,
    children,
  } = props;

  const handleMouseEnter = (event: any) => {
    setHovering(true);
    if (onMouseEnter) {
      onMouseEnter(event);
    }
  };

  const handleMouseLeave = (event: any) => {
    setHovering(false);
    if (onMouseLeave) {
      onMouseLeave(event);
    }
  };

  const indicatorStyles =
    menuConfig && menuConfig.indicatorStyles
      ? { ...menuConfig.indicatorStyles }
      : null;

  if (indicatorStyles && menuConfig.hover) {
    indicatorStyles.opacity = hovering ? 1 : 0;
  }

  const handleMenuChange = (e: any) => {
    e.target.id = id;
    e.target.count = count;
    e.target.listName = listName;
    e.target.shared = shared;
    e.target.listType = listType;
    e.target.tableColumns = tableColumns;

    // Need to pass the filters if the label is load attributes
    if (e.target.label.toLocaleLowerCase() === 'load attributes in explore')
      e.target.loadAttributes = loadAttributes;

    menuConfig.onChange(e);
  };

  const handleClick = (event) => {
    if (handleAccessibilityClick(event) && onClick) {
      onClick(event);
    }
  };

  const rowProps = onClick
    ? {
        role: 'button',
        tabIndex: 0,
        onClick: handleClick,
        onKeyDown: handleClick,
      }
    : {};

  return (
    <div
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      style={{ color }}
      className={classes.row}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...rowProps}
    >
      {children}
      {menuConfig && menuConfig.use ? (
        // Click or KeyDown events on Menu should not reach Row.
        // eslint-disable-next-line jsx-a11y/no-static-element-interactions
        <div
          onFocus={() => setHovering(true)}
          onBlur={() => setHovering(false)}
          className={classes.menuContainer}
          onMouseLeave={handleMouseLeave}
          onClick={(event) => event.stopPropagation()}
          onKeyDown={(event) => event.stopPropagation()}
        >
          <Menu
            items={menuConfig.items}
            width="217px"
            indicator={menuConfig.indicator}
            indicatorStyles={indicatorStyles}
            onChange={handleMenuChange}
            ariaLabel="Table Row Menu"
          />
        </div>
      ) : null}
    </div>
  );
};
TableRow.defaultProps = {
  shared: '',
  count: 0,
  id: '',
  loadAttributes: '',
  color: '',
  padding: '',
  listName: '',
  alignItems: '',
  justifyContent: '',
  listType: '',
  tableColumns: [],
  classes: {},
  menuConfig: {
    use: false,
    hover: false,
    items: [],
    indicator: {},
    indicatorStyles: {},
    onChange: () => {},
  },
  onMouseEnter: () => {},
  onMouseLeave: () => {},
  onClick: undefined,
};
export default injectSheet(styleSheet)(TableRow);
